import {request} from '@/helpers/apiClient'
import {SKU_CONFIG} from '@/utils/constants/apiConfig/suggestedSkuConfig'
import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const getSuggestedSkuFile = (queryParams = '') => request(SKU_CONFIG.SKU_CSV_DOWNLOAD(queryParams))
